import React, { FC } from 'react';

import styles from './jobVaultShowListStyles.scss';

const JobVaultShowList: FC<{ list: { label: string; data: string }[] }> = ({ list }) => (
  <div className={styles.container}>
    {list.map(
      ({ label, data }) =>
        data && (
          <div key={label}>
            <strong className={styles.label}>{label}: </strong>
            {data}
          </div>
        )
    )}
  </div>
);

export default JobVaultShowList;
